import { AlertTriangle, ChevronRight, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { NearbyMatchCard } from './NearbyMatchCard';
import { useNavigate } from 'react-router-dom';
import type { NearbyMatch } from '@/hooks/useNearbyMatches';
import { cn } from '@/lib/utils';

interface UrgentMatchesSectionProps {
  matches: NearbyMatch[];
  isLoading?: boolean;
}

export function UrgentMatchesSection({ matches, isLoading }: UrgentMatchesSectionProps) {
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <section className="animate-pulse">
        <div className="h-8 bg-muted rounded w-48 mb-3" />
        <div className="h-40 bg-muted rounded-xl" />
      </section>
    );
  }

  if (matches.length === 0) return null;

  return (
    <section className="relative">
      {/* Header with urgent styling */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-destructive/20">
            <AlertTriangle className="w-5 h-5 text-destructive" />
          </div>
          <div>
            <h3 className="font-bold text-foreground">Cần người gấp!</h3>
            <p className="text-xs text-destructive flex items-center gap-1">
              <Clock className="w-3 h-3" />
              Bắt đầu trong vòng 2 giờ
            </p>
          </div>
        </div>
        <Button 
          variant="ghost" 
          size="sm" 
          className="text-destructive hover:text-destructive/80 hover:bg-destructive/10"
          onClick={() => navigate('/matches')}
        >
          Tất cả
          <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      </div>

      {/* Urgent matches carousel */}
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-4 px-4 snap-x snap-mandatory scrollbar-hide">
        {matches.slice(0, 5).map((match) => (
          <div key={match.id} className="snap-start flex-shrink-0 w-[280px]">
            <NearbyMatchCard match={match} isUrgent />
          </div>
        ))}
      </div>
    </section>
  );
}
